import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';

export const ModulePageHero = ({
  title,
  description,
  icon: Icon,
  stats = [],
  actions = null,
  badge = null,
  footer = null,
  className = '',
  compact = false,
  testId = 'module-page-hero',
}) => {
  const containerClasses = compact
    ? 'rounded-[22px] border border-slate-200 bg-[radial-gradient(circle_at_top_left,_rgba(14,165,233,0.08),_transparent_20%),linear-gradient(180deg,_#ffffff,_#f8fafc)] p-3 shadow-sm md:p-4'
    : 'rounded-[30px] border border-slate-200 bg-[radial-gradient(circle_at_top_left,_rgba(14,165,233,0.12),_transparent_28%),linear-gradient(180deg,_#ffffff,_#f8fafc)] p-5 shadow-sm md:p-7';

  return (
    <div className={`${containerClasses} ${className}`.trim()} data-testid={testId}>
      <div className={`flex flex-col ${compact ? 'gap-2' : 'gap-5'} xl:flex-row xl:items-start xl:justify-between`}>
        <div className={compact ? 'space-y-1.5' : 'space-y-3'}>
          <div className="flex flex-wrap items-center gap-3">
            {Icon ? (
              <div className={`flex items-center justify-center bg-slate-900 text-white shadow-sm ${compact ? 'h-8 w-8 rounded-xl' : 'h-12 w-12 rounded-2xl'}`}>
                <Icon className={compact ? 'h-4 w-4' : 'h-6 w-6'} />
              </div>
            ) : null}
            {badge ? <Badge variant="outline" className="rounded-full px-3 py-1 text-xs uppercase tracking-wide">{badge}</Badge> : null}
          </div>
          <div>
            <h1 className={`${compact ? 'text-xl' : 'text-3xl'} font-semibold tracking-tight text-slate-900`}>{title}</h1>
            {description ? <p className={`mt-1 ${compact ? 'max-w-4xl text-xs' : 'max-w-3xl text-sm'} text-slate-600`}>{description}</p> : null}
          </div>
        </div>

        {actions ? <div className="flex flex-wrap items-center gap-2">{actions}</div> : null}
      </div>

      {stats.length > 0 ? (
        <div className={`${compact ? 'mt-2 grid gap-2 md:grid-cols-2 xl:grid-cols-4' : 'mt-6 grid gap-3 md:grid-cols-2 xl:grid-cols-4'}`} data-testid={`${testId}-stats`}>
          {stats.map((stat) => (
            <Card key={stat.label} className="border-slate-200 bg-white/90 shadow-none">
              <CardContent className={compact ? 'p-3' : 'pt-5'}>
                <p className="text-xs uppercase tracking-wide text-slate-500">{stat.label}</p>
                <p className={`${compact ? 'mt-1 text-lg' : 'mt-2 text-2xl'} font-semibold text-slate-900`}>{stat.value}</p>
                {stat.helper ? <p className={`${compact ? 'mt-0.5 text-[11px]' : 'mt-1 text-xs'} text-slate-500`}>{stat.helper}</p> : null}
              </CardContent>
            </Card>
          ))}
        </div>
      ) : null}

      {footer ? (
        <div className={`${compact ? 'mt-3 pt-3' : 'mt-4 pt-4'} border-t border-slate-200/80`} data-testid={`${testId}-footer`}>
          {footer}
        </div>
      ) : null}
    </div>
  );
};